const GoogleAdSmall1 = () => {
  return (
    <>
      <div className="rbt-callto-action rbt-cta-default style-4 bg-gradient-3 mt--20">
        <a href="https://www.kqzyfj.com/click-101154220-15552634" target="_top">
          <img src="https://www.lduhtrp.net/image-101154220-15552634" width="300" height="100" alt="" border="0" /></a>
      </div>
    </>
  );
};

export default GoogleAdSmall1;
